import { ActionPlanRiskConsequence, ActionPlanRiskLikelihood, RiskCategory } from "../amorg-common";

export const riskAssessment = {
    calculateRisk,
    getConsequenceIndex,
    getLikelihoodIndex,
    getRiskIndex
}

function calculateRisk(consequence:ActionPlanRiskConsequence, 
    likelihood:ActionPlanRiskLikelihood
): RiskCategory
{
    const cases:[ActionPlanRiskConsequence, ActionPlanRiskLikelihood, RiskCategory][] = [
        ["1 - small",           "1 - unlikely",     'Acceptabel risiko'],
        ["1 - small",           "2 - rare",         'Acceptabel risiko'],
        ["1 - small",           "3 - possible",     'Lille risiko'],
        ["1 - small",           "4 - likely",       'Lille risiko'],
        ["2 - significant",     "1 - unlikely",     'Acceptabel risiko'],
        ["2 - significant",     "2 - rare",         'Lille risiko'],
        ["2 - significant",     "3 - possible",     'Moderat risiko'],
        ["2 - significant",     "4 - likely",       'Moderat risiko'],
        ["3 - severe",          "1 - unlikely",     'Lille risiko'],
        ["3 - severe",          "2 - rare",         'Moderat risiko'],
        ["3 - severe",          "3 - possible",     'Moderat risiko'],
        ["3 - severe",          "4 - likely",       'Høj risiko'],
        ["4 - catastrophic",    "1 - unlikely",     'Lille risiko'],
        ["4 - catastrophic",    "2 - rare",         'Moderat risiko'],
        ["4 - catastrophic",    "3 - possible",     'Høj risiko'],
        ["4 - catastrophic",    "4 - likely",       'Høj risiko'],
    ];

    const found = cases.find(c => c[0] === consequence && c[1] === likelihood);
    if(!found)
        throw new Error(`Invalid consequence (${consequence}) or likelihood (${likelihood})`);
    
    return found[2];
}

function getLikelihoodIndex(likelihood: ActionPlanRiskLikelihood): number
{
    let likelihoodIndex = 0;
    if(likelihood === '1 - unlikely') likelihoodIndex = 0;
    else if(likelihood === '2 - rare') likelihoodIndex = 1;
    else if(likelihood === '3 - possible') likelihoodIndex = 2;
    else if(likelihood === '4 - likely') likelihoodIndex = 3;
    else
        throw new Error('Unknown likelihood value: ' + likelihood);

    return likelihoodIndex;
}

function getConsequenceIndex(consequence: ActionPlanRiskConsequence): number
{
    let consequenceIndex = 0;
    if(consequence === '1 - small') consequenceIndex = 0;
    else if(consequence === '2 - significant') consequenceIndex = 1;
    else if(consequence === '3 - severe') consequenceIndex = 2;
    else if(consequence === '4 - catastrophic') consequenceIndex = 3;
    else
        throw new Error('Unknown consequence value: ' + consequence);

    return consequenceIndex;
}

function getRiskIndex(risk: RiskCategory): number
{
    let riskIndex = 0;
    if(risk === 'Acceptabel risiko') riskIndex = 0;
    else if(risk === 'Lille risiko') riskIndex = 1;
    else if(risk === 'Moderat risiko') riskIndex = 2;
    else if(risk === 'Høj risiko') riskIndex = 3;
    
    return riskIndex;
}